export const REGISTRATION_ROUTE_PATH = '/registration'

const REGISTRATION_CTA_TEXTS = [
  'Начать первый уровень',
  'Создать команду',
  'Создать аккаунт',
]

type AssetMap = Record<string, string>

function extractLandingMarkup(sourceHtml: string): string {
  const dcMatch = sourceHtml.match(/<\/helmet>\s*([\s\S]*?)\s*<\/x-dc>/i)
  const bodyMatch = sourceHtml.match(/<body[^>]*>([\s\S]*?)<\/body>/i)
  return dcMatch?.[1] ?? bodyMatch?.[1] ?? sourceHtml
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

function markRegistrationCtas(markup: string): string {
  return markup.replace(/<a\b([^>]*)>([\s\S]*?)<\/a>/gi, (anchor, attrs: string, content: string) => {
    const text = content.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()
    const isRegistrationCta = REGISTRATION_CTA_TEXTS.some((ctaText) => text.includes(ctaText))

    if (!isRegistrationCta) {
      return anchor
    }

    const attrsWithoutHref = attrs.replace(/\s+href=("[^"]*"|'[^']*'|[^\s>]*)/i, '')
    return `<a href="${REGISTRATION_ROUTE_PATH}" data-referral-register-cta="true"${attrsWithoutHref}>${content}</a>`
  })
}

function rewriteAssets(markup: string, assets: AssetMap): string {
  return Object.entries(assets).reduce((html, [assetName, assetUrl]) => {
    const encodedName = escapeRegExp(assetName)
    return html.replace(new RegExp(`(src=["'])assets/${encodedName}(["'])`, 'g'), `$1${assetUrl}$2`)
  }, markup)
}

export function buildReferralLandingHtml(sourceHtml: string, assets: AssetMap): string {
  const withoutScripts = extractLandingMarkup(sourceHtml)
    .replace(/<script\b[\s\S]*?<\/script>/gi, '')
    .replace(/\sref="\{\{\s*countRef\s*\}\}"/g, ' data-referral-count="true"')
    .replace(/\sref="\{\{[^"}]+\}\}"/g, '')

  return markRegistrationCtas(rewriteAssets(withoutScripts, assets)).trim()
}

export function persistReferralCode(login: string, doc: Document = document): void {
  if (!login) {
    return
  }

  localStorage.setItem('partner_referral_code', login)

  const expiryDate = new Date()
  expiryDate.setDate(expiryDate.getDate() + 30)
  doc.cookie = `referal=${encodeURIComponent(login)}; expires=${expiryDate.toUTCString()}; path=/`
}
